var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.mainTable.visible
            ? _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c("search-card", {
                        attrs: {
                          form: _vm.mainTable.searchForm,
                          "table-load-event": _vm.handleSearch,
                          "table-search": _vm.mainTable.search,
                          colSpan: 4,
                          searchBtnColSpan: 4,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "Card",
        [
          _c(
            "Row",
            { staticClass: "tool-bar-row", attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c("div", { staticClass: "left-bar" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("定金单定金统计"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "filter-controls" },
                      [
                        _c("span", { staticClass: "filter-label" }, [
                          _vm._v("统计时间:"),
                        ]),
                        _c(
                          "RadioGroup",
                          {
                            attrs: { size: "small" },
                            on: { "on-change": _vm.handleTimeModeChange },
                            model: {
                              value: _vm.timeMode,
                              callback: function ($$v) {
                                _vm.timeMode = $$v
                              },
                              expression: "timeMode",
                            },
                          },
                          [
                            _c("Radio", { attrs: { label: "range" } }, [
                              _vm._v("时间范围"),
                            ]),
                            _c("Radio", { attrs: { label: "deadline" } }, [
                              _vm._v("时间截止"),
                            ]),
                          ],
                          1
                        ),
                        _vm.timeMode === "range"
                          ? _c("DatePicker", {
                              staticClass: "date-picker",
                              attrs: {
                                type: "daterange",
                                size: "small",
                                transfer: "",
                                clearable: false,
                                placement: "bottom-end",
                                placeholder: "选择期初和期末时间",
                              },
                              on: { "on-change": _vm.handleDateChange },
                              model: {
                                value: _vm.dateRange,
                                callback: function ($$v) {
                                  _vm.dateRange = $$v
                                },
                                expression: "dateRange",
                              },
                            })
                          : _vm._e(),
                        _vm.timeMode === "deadline"
                          ? _c("DatePicker", {
                              staticClass: "date-picker",
                              attrs: {
                                type: "date",
                                size: "small",
                                transfer: "",
                                clearable: false,
                                placement: "bottom-end",
                                placeholder: "选择截止时间",
                              },
                              on: { "on-change": _vm.handleEndDateChange },
                              model: {
                                value: _vm.endDate,
                                callback: function ($$v) {
                                  _vm.endDate = $$v
                                },
                                expression: "endDate",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "right-bar" },
                    [
                      _c(
                        "Button",
                        {
                          staticClass: "action-btn",
                          attrs: {
                            type: "info",
                            size: "small",
                            icon: "ios-send",
                            loading: _vm.exportLoading,
                          },
                          on: { click: _vm.handleExport },
                        },
                        [
                          _vm._v(
                            "\n                            导出\n                        "
                          ),
                        ]
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "action-btn",
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "ios-search",
                          },
                          on: { click: _vm.toggleSearch },
                        },
                        [
                          _vm._v(
                            "\n                            搜索\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "formula-legend-container" }, [
            _c("div", { staticClass: "legend-item" }, [
              _c("div", { staticClass: "tag income" }, [_vm._v("收定金")]),
              _c("span", { staticClass: "equals" }, [_vm._v("=")]),
              _c("span", { staticClass: "formula-text" }, [
                _vm._v("定金已支付的定金单定金 + 全额支付的定金单定金"),
              ]),
            ]),
            _c("div", { staticClass: "vertical-divider" }),
            _c("div", { staticClass: "legend-item" }, [
              _c("div", { staticClass: "tag expense" }, [_vm._v("退定金")]),
              _c("span", { staticClass: "equals" }, [_vm._v("=")]),
              _c("span", { staticClass: "formula-text" }, [
                _vm._v(
                  "撤销 + 关闭 + 已发货定金单 + 部分发货的定金单定金 + 违约"
                ),
              ]),
            ]),
          ]),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("stand-pagination-table", {
                    attrs: {
                      columns: _vm.mainTable.columns,
                      data: _vm.mainTable.data,
                      loading: _vm.mainTable.loading,
                      "table-search": _vm.mainTable.search,
                      "table-load-event": _vm.handleSearch,
                      autoHeight: true,
                      summaryLabelField: "depositBillRecordCode",
                      summaryFields: ["inflow", "consume"],
                      totalSummaryFieldDatas: _vm.mainTable.sumData,
                      showPage: true,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }